import { configureStore } from '@reduxjs/toolkit';

import aclReducer from './aclSlice';
import esntlReducer from './esntlSlice';
import taskReducer from './taskSlice';

const store = configureStore({
  reducer: {
    tasks: taskReducer,
    acl: aclReducer,
    esntl: esntlReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
